export default __webpack_public_path__ + "static/media/Realcase-socialMedia-mobile-en.066bff40.png";